import React, { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function CompraSaldo({ id_vendedor, saldo }) {
  const [monto, setMonto] = useState('');
  const [comprando, setComprando] = useState(false);

  const montoNum = parseFloat(monto) || 0;

  const comprar = async () => {
    if (montoNum < 500 || montoNum > 25000) {
      toast.warn('Monto mínimo $500, máximo $25,000');
      return;
    }
    setComprando(true);
    try {
      const response = await axios.post(`${API}/prod/compra_saldo`, {
        id_vendedor,
        monto: montoNum,
        app: '1',
      });
      const data = response.data;
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      if (body.payment_request_id) {
        window.location.href = `https://pago.clip.mx/${body.payment_request_id}`;
      } else if (body.location === 'saldo') {
        toast.success('Saldo acreditado');
      } else {
        toast.error('Error al generar pago');
      }
    } catch {
      toast.error('Error de conexión');
    } finally {
      setComprando(false);
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <h2>💳 Compra de Saldo</h2>

      <div style={{ background: '#e0f2e5', borderRadius: 14, padding: 16, marginBottom: 20, textAlign: 'center' }}>
        <div style={{ fontSize: 13, color: '#6b8f71' }}>Tu saldo actual</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#1a3a2a' }}>${saldo || 0}</div>
      </div>

      <div style={{ background: '#fff', borderRadius: 16, padding: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#1a3a2a', marginBottom: 12 }}>¿Cuánto quieres comprar?</div>
        <input
          type="number"
          placeholder="Monto ($500 - $25,000)"
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
          style={{ width: '100%', padding: 14, borderRadius: 12, border: '2px solid #d4e8d6', fontSize: 16, boxSizing: 'border-box', marginBottom: 12 }}
        />

        {montoNum >= 500 && (
          <div style={{ background: '#f0f7f2', borderRadius: 12, padding: 14, marginBottom: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#1a3a2a' }}>Monto a pagar</span>
              <span style={{ fontSize: 18, fontWeight: 800, color: '#1a3a2a' }}>${montoNum.toLocaleString()}</span>
            </div>
          </div>
        )}

        <button onClick={comprar} disabled={comprando || montoNum < 500} className="orange-button" style={{ width: '100%' }}>
          {comprando ? '⏳ Procesando...' : '💳 Comprar Saldo'}
        </button>
      </div>

      <div style={{ fontSize: 11, color: '#9ca3af', textAlign: 'center' }}>*Monto mínimo $500, máximo $25,000</div>

      <div style={{ height: 80 }} />
    </div>
  );
}
